import { accountUserDetailKey } from '../../common/queryKeys';

export const USER_GRADE_QUERY_KEYS = {
  //등급 정보 탭에서 호춣하는 모든 쿼리의 공통 key
  ALL: [...accountUserDetailKey, 'grade'],
  //등급 정보 > 유저 등급 리스트 쿼리 key
  GRADES: [...accountUserDetailKey, 'grade', 'list'],
  //등급 정보 > 유저 등급 요약 정보 쿼리 key
  SUMMARY: [...accountUserDetailKey, 'grade', 'summary'],
  //등급 정보 > 유저 등급 히스토리 정보 쿼리 key
  HISTORIES: [...accountUserDetailKey, 'grade', 'histories'],
};
